import React, { useContext } from 'react';
import styles from './PaymentMethod.module.css';
import Methods from '../../components/Methods';
import Address from '../../components/Address';
import { Footer } from '../../components/Footer';
import GlobalContext from '../../context/Global/Context';

const PaymentMethod = () => {
  const globalContext = useContext(GlobalContext);
  const { isCitaFlow } = globalContext;

  return (
    <div className={styles.container}>
      {!isCitaFlow && <Address />}
      <Methods />
      <Footer />
    </div>
  );
};

export default PaymentMethod;
